<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Registrá</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Registrá</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="create-account-area pt-100 pb-100 mx">
    <div class="container">
        <div class="create-photo">
            <div class="already-create" >
                <span>Bo tin un kuenta?</span>
                <a routerLink="/login">Log In</a>
            </div>

            <form>
            
            </form>
        </div>

        <div class="create-information">
            <form [formGroup]="createAccountForm" (ngSubmit)="onSubmit()">
                <h3>Registrá un kuenta</h3>
                <div class="row">
                    <div *ngIf="errorMessage" class="alert alert-danger">
                        {{ errorMessage }}
                      </div>
                </div>
               

                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="firstName">Nòmber kompletu</label>
                            <input type="text" id="firstName" class="form-control" formControlName="firstName" [class.is-invalid]="createAccountForm.get('firstName').touched && createAccountForm.get('firstName').invalid">
                            <div *ngIf="createAccountForm.get('firstName').touched && createAccountForm.get('firstName').invalid" class="invalid-feedback">
                              <small *ngIf="createAccountForm.get('firstName').errors.required">Nòmber ta rekerí.</small>
                              <small *ngIf="createAccountForm.get('firstName').errors.minlength">Nòmber mester tin por lo menos 2 lèter.</small>
                            </div>
                          </div>
                    
                    </div>


                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="lastName">Fam</label>
                            <input type="text" id="lastName" class="form-control" formControlName="lastName" [class.is-invalid]="createAccountForm.get('lastName').touched && createAccountForm.get('lastName').invalid">
                            <div *ngIf="createAccountForm.get('lastName').touched && createAccountForm.get('lastName').invalid" class="invalid-feedback">
                                <small *ngIf="createAccountForm.get('lastName').errors.required">Fam ta rekerí.</small>
                                <small *ngIf="createAccountForm.get('lastName').errors.minlength">Fam mester tin por lo menos 2 lèter</small>
                            </div>
                          </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" class="form-control" formControlName="email" [class.is-invalid]="createAccountForm.get('email').touched && createAccountForm.get('email').invalid">
                            <div *ngIf="createAccountForm.get('email').touched && createAccountForm.get('email').invalid" class="invalid-feedback">
                                <small *ngIf="createAccountForm.get('email').errors.required">Email ta rekerí.</small>
                                <small *ngIf="createAccountForm.get('email').errors.minlength">Email no ta korekto.</small>
                            </div>
                          </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="dateOfBirth">Fecha di Nasementu</label>
                            <input type="date" id="dateOfBirth" class="form-control" formControlName="dateOfBirth">
                            <div *ngIf="createAccountForm.get('dateOfBirth').touched && createAccountForm.get('dateOfBirth').errors">
                              <small class="text-danger" *ngIf="createAccountForm.get('dateOfBirth').errors['required']">Fecha di nasementu ta rekerí.</small>
                            </div>
                          </div>
                    
                    </div>




                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="password">Password</label>
                            <input type="password" id="password" class="form-control" formControlName="password">
                            <div *ngIf="createAccountForm.get('password').touched && createAccountForm.get('password').errors">
                              <small class="text-danger" *ngIf="createAccountForm.get('password').errors['required']">Password is rekerï.</small>
                              <small class="text-danger" *ngIf="createAccountForm.get('password').errors['minLength']">Password mester tin un kombinashon minimo di 6 lèter, number i/of simbulo.</small>
                            </div>
                          </div>
                    
                    
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <label for="confirmPassword">Konfirmá Password</label>
                            <input type="password" id="confirmPassword" class="form-control" formControlName="confirmPassword">
                            <div *ngIf="createAccountForm.get('confirmPassword').touched && createAccountForm.get('confirmPassword').errors">
                              <small class="text-danger" *ngIf="createAccountForm.get('confirmPassword').errors['required']">Porfabor konfirmá bo password</small>
                              <small class="text-danger" *ngIf="createAccountForm.get('confirmPassword').errors['mustMatch']">Passwordsnan no ta meskos.</small>
                            </div>
                          </div>
                    </div>


                </div>
                <div class="text-left">
                    <button type="submit" class="btn create-ac-btn" [disabled]="createAccountForm.invalid">Registrá</button>
                </div>
            </form>
        </div>
  
    
    </div>
</div>